(function() {
  if (window.oettingerMegaMenuInitialized) return;
  window.oettingerMegaMenuInitialized = true;

  window.oettingerSetMegaMenuPanel = function(trigger) {
    const drawer = trigger.closest('.oettinger-mega-drawer');
    if (!drawer) return;

    const key = trigger.dataset.menuKey;
    drawer.querySelectorAll('[data-oettinger-mega-menu-trigger]').forEach(function(item) {
      const isActive = item === trigger;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    drawer.querySelectorAll('[data-oettinger-mega-menu-panel]').forEach(function(panel) {
      const isActive = panel.dataset.oettingerMegaMenuPanel === key;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  };

  function handlePanelIntent(event) {
    const trigger = event.target.closest('[data-oettinger-mega-menu-trigger]');
    if (!trigger) return;
    window.oettingerSetMegaMenuPanel(trigger);
  }

  function handleTabKeydown(event) {
    const trigger = event.target.closest('[data-oettinger-mega-menu-trigger]');
    if (!trigger) return;

    const triggers = Array.from(
      trigger.closest('[role="tablist"]')?.querySelectorAll('[data-oettinger-mega-menu-trigger]') || []
    );
    if (!triggers.length) return;

    const currentIndex = triggers.indexOf(trigger);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % triggers.length;
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + triggers.length) % triggers.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = triggers.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    triggers[nextIndex].focus();
    window.oettingerSetMegaMenuPanel(triggers[nextIndex]);
  }

  function syncCardTitleTooltips() {
    const supportsHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;

    document.querySelectorAll('.oettinger-mega-drawer__card-title[data-title]').forEach(function(title) {
      if (supportsHover) {
        title.setAttribute('title', title.dataset.title);
      } else {
        title.removeAttribute('title');
      }
    });
  }

  document.addEventListener('mouseover', handlePanelIntent);
  document.addEventListener('focusin', handlePanelIntent);
  document.addEventListener('keydown', handleTabKeydown);
  window.addEventListener('resize', syncCardTitleTooltips);
  syncCardTitleTooltips();
})();
